(function () {
  const STORAGE_KEY = 'toniWishlist';
  const EXPIRY_DAYS = 30;
  const EXPIRY_MS = EXPIRY_DAYS * 24 * 60 * 60 * 1000;
  const SHOW_PRICES = false;

  function now() {
    return Date.now();
  }

  function getWishlist() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));

      if (!saved || !Array.isArray(saved.items)) {
        return { items: [] };
      }

      const validItems = saved.items.filter(function (item) {
        return item.addedAt && now() - item.addedAt < EXPIRY_MS;
      });

      return { items: validItems };
    } catch (error) {
      return { items: [] };
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
    updateButtons();
    updateHeaderCount();
  }

  function isInWishlist(handle) {
    return getWishlist().items.some(function (item) {
      return item.handle === handle;
    });
  }

  function addItemFromButton(button) {
  const wishlist = getWishlist();

  const item = {
    handle: button.getAttribute('data-product-handle'),
    productId: button.getAttribute('data-product-id'),
    productTitle: button.getAttribute('data-product-title'),
    variantId: button.getAttribute('data-variant-id'),
    variantSku: button.getAttribute('data-variant-sku'),
    variantTitle: button.getAttribute('data-variant-title'),
    variantImage: button.getAttribute('data-variant-image'),
    addedAt: now()
  };

  if (!item.handle) return;

  wishlist.items = wishlist.items.filter(function (existingItem) {
    return existingItem.handle !== item.handle;
  });

  wishlist.items.push(item);

  saveWishlist(wishlist);
}

  function removeItem(handle) {
    const wishlist = getWishlist();

    wishlist.items = wishlist.items.filter(function (item) {
      return item.handle !== handle;
    });

    saveWishlist(wishlist);
    renderWishlistPage();
  }

function toggleItem(button) {
  const handle = button.getAttribute('data-product-handle');

  if (isInWishlist(handle)) {
    removeItem(handle);
    showWishlistAlert('Fjernet fra wishlist');
  } else {
    addItemFromButton(button);
    showWishlistAlert('Tilføjet til wishlist');
  }
}

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      const handle = button.getAttribute('data-product-handle');
      const active = isInWishlist(handle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const text = button.querySelector('[data-wishlist-text]');
if (text) {
  text.textContent = active ? 'Tilføjet til wishlist' : 'Tilføj til wishlist';
}
    });
  }

  function updateHeaderCount() {
  const count = getWishlist().items.length;

  document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
    const oldCount = el.textContent;

    el.textContent = count;
    el.hidden = count === 0;

    if (oldCount !== String(count) && count > 0) {
      el.classList.remove('is-animating');
      void el.offsetWidth;
      el.classList.add('is-animating');
    }
  });
}

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }

    return (cents / 100).toLocaleString('da-DK', {
      style: 'currency',
      currency: 'DKK'
    });
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product not found');
        return response.json();
      });
  }

  function renderProductCard(product, item) {
const image = item && item.variantImage ? item.variantImage : product.featured_image || '';
const sku = item && item.variantSku ? item.variantSku : '';
const url = product.url + (item && item.variantId ? '?variant=' + item.variantId : '');

  return `
    <div class="product-grid--item wishlist-product-card" data-wishlist-product="${product.handle}">
      <div class="product-grid--item-top">
        <a href="${url}" class="title">
          ${product.title}
        </a>

        <div class="product-grid--item-content wishlist">
          <div class="details">
            ${sku ? `<p class="sku">${sku}</p>` : ''}
          </div>
        </div>
      </div>

      <div class="product-grid--item-image">
        <a href="${url}" cursor-class="arrow">
          ${image ? `<img src="${image}" alt="${product.title}">` : ''}
        </a>
      </div>

     <button
  type="button"
  class="main-link wishlist-remove-link"
  data-wishlist-remove="${product.handle}"
>
  <span class="nav-label" style="width: auto !important;"></span>
  <span class="wishlist-remove-link__text">Fjern</span>
</button>
    </div>
  `;
}

function getShareUrl() {
  const wishlist = getWishlist();

  const items = wishlist.items.map(function (item) {
    return item.handle + ':' + item.variantId;
  });

  const url = new URL(window.location.origin + '/pages/wishlist');

  if (items.length) {
    url.searchParams.set('items', items.join(','));
  }

  return url.toString();
}

function showWishlistAlert(message) {
  const existing = document.querySelector('.wishlist-alert');
  if (existing) existing.remove();

  const alert = document.createElement('a');
  alert.className = 'wishlist-alert';
  alert.href = '/pages/wishlist';
  alert.textContent = message;

  document.body.appendChild(alert);

  setTimeout(function () {
    alert.classList.add('is-visible');
  }, 10);

  setTimeout(function () {
    alert.classList.remove('is-visible');

    setTimeout(function () {
      alert.remove();
    }, 300);
  }, 2200);
}

  function renderWishlistPage() {
  const container = document.querySelector('[data-wishlist-page]');
  const empty = document.querySelector('[data-wishlist-empty]');

  if (!container) return;

  const wishlist = getWishlist();
  const params = new URLSearchParams(window.location.search);
const sharedItems = params.get('items');

if (sharedItems) {
  wishlist.items = sharedItems.split(',').map(function (entry) {
    const parts = entry.split(':');

    return {
      handle: parts[0],
      variantId: parts[1] || '',
      addedAt: now()
    };
  });
}

  container.innerHTML = '';

  if (!wishlist.items.length) {
    if (empty) empty.hidden = false;
    return;
  }
if (empty) empty.hidden = true;

Promise.all(
  wishlist.items.map(function (item) {
    return fetchProduct(item.handle)
      .then(function (product) {
        if (item.variantId) {
          const variant = product.variants.find(function (v) {
            return String(v.id) === String(item.variantId);
          });

          if (variant) {
            item.variantSku = variant.sku || '';
            item.variantTitle = variant.title || '';
            if (variant) {
  item.variantSku = variant.sku || '';
  item.variantTitle = variant.title || '';

  if (variant.featured_image && variant.featured_image.src) {
    item.variantImage = variant.featured_image.src;
  } else {
    item.variantImage = product.featured_image || '';
  }
}
          }
        }

        return { product: product, item: item };
      })
      .catch(function () {
        return null;
      });
  })
).then(function (results) {
  const validResults = results.filter(Boolean);

  if (!validResults.length) {
    container.innerHTML = '';
    if (empty) empty.hidden = false;
    return;
  }

  container.innerHTML = validResults.map(function (result) {
    return renderProductCard(result.product, result.item);
  }).join('');
});
}

function bindButtons() {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-wishlist-button]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const handle = button.getAttribute('data-product-handle');

    if (!handle) return;

    toggleItem(button);
  }, true);

  document.addEventListener('click', function (event) {
    const removeButton = event.target.closest('[data-wishlist-remove]');

    if (!removeButton) return;

    event.preventDefault();

    const handle = removeButton.getAttribute('data-wishlist-remove');

    if (!handle) return;

    removeItem(handle);
  });

  document.addEventListener('click', function (event) {
    const shareButton = event.target.closest('[data-wishlist-share]');

    if (!shareButton) return;

    event.preventDefault();

    const shareUrl = getShareUrl();

    navigator.clipboard.writeText(shareUrl).then(function () {
      showWishlistAlert('URL copied');
    });
  });
}

  function init() {
    bindButtons();
    saveWishlist(getWishlist());
    updateButtons();
    updateHeaderCount();
    renderWishlistPage();
  }

  document.addEventListener('DOMContentLoaded', init);
})();